module.exports = __webpack_public_path__ + "img/tet-img.bb5bfc1a.png";